import mutations, { initialState } from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state() {
    return initialState();
  },
  mutations,
  actions,
  getters,
  namespaced: true,
};
